import { ENV_IS_ENABLED_YANDEX_METRIKA } from "~/configs/consts";

export const sendYandexMetrika = (id: number, action: string, goalName: string | object): void => {
  if (ENV_IS_ENABLED_YANDEX_METRIKA === "false") {
    return;
  }

  try {
    ym(id, action, goalName);
  } catch {
    // TODO: Отсылать ошибку в сентри, в консоль ничего не выводить
    // console.log("Yandex Metrika error:", error);
  }
};
